import {TrialPill} from 'shells/acorn-pill/svg/trial';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {GetLimits_limits as Limits} from 'nutshell-graphql-types';

import {PlanCard} from './plan-card';

interface Props {
    limits: Limits | null;
}

export function OutOfCreditsTrialNonAdminContent(props: Props) {
    const trialPill = <TrialPill height={24} />;

    return (
        <Stack spacing={16}>
            <Body size='xlarge' isBold={true} color='dark'>
                You’re out of AI outcomes
            </Body>
            <PlanCard
                planPill={trialPill}
                usageText='Your team’s monthly AI outcomes'
                usageCurrent={props.limits?.currentUsage ?? 0}
                usageLimit={props.limits?.currentPlanLimit ?? 0}
            />
            <Body color='dark'>Contact an admin to purchase a Nutshell plan</Body>
        </Stack>
    );
}
